var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "format-columns",
    d: "M3,3h7.111V4.778H3V3m8.889,0H19V4.778H11.889V3M3,6.556h7.111V8.333H3V6.556m8.889,0H19V8.333H11.889V6.556M3,10.111h7.111v1.778H3V10.111m8.889,0H19v1.778H11.889V10.111M3,13.667h7.111v1.778H3V13.667m8.889,0H19v1.778H11.889V13.667M3,17.222h7.111V19H3V17.222m8.889,0H19V19H11.889Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatColumns);
export default __webpack_public_path__ + "static/media/format_columns.f0218bb1dc6a80c52177bfb41b3daf53.svg";
export { ForwardRef as ReactComponent };